import { Modal } from 'ant-design-vue'
import $t from '@/lang/dc-I18n'
// 已选中的两条数据
export default {
  delete: (obj: any) => {
    let content = ''
    if (obj.name) {
      content = $t('tips.Wv3DcS', { name: obj.name })
    } else {
      content = $t('tips.4xZefE')
    }
    return Modal.error({
      closable: true,
      title: $t('tips.HKA5Fu'),
      content,
      okCancel: true,
      cancelText: $t('btn.cancel'),
      okText: $t('btn.del'),
      ...obj
    })
  },
  reset: (obj: any) => {
    return Modal.warning({
      closable: true,
      title: $t('tips.Bugmho'),
      content: $t('tips.Q7gWbt', { name: obj.name }),
      okCancel: true,
      cancelText: $t('btn.cancel'),
      okText: $t('btn.reset'),
      ...obj
    })
  },
  switch: (obj: any) => {
    // 启用禁用
    return Modal.warning({
      closable: true,
      title: $t('tips.ME2FQvx'),
      content: $t('tips.YTkYZA'),
      okCancel: true,
      cancelText: $t('btn.cancel'),
      okText: $t('btn.confirm'),
      ...obj
    })
  }
}
